import { Controller } from "@hotwired/stimulus";
import { Target, TypedController } from "@vytant/stimulus-decorators";

@TypedController
export default class extends Controller<HTMLAnchorElement | HTMLButtonElement> {
  connect() {
    this.element.addEventListener("click", (event) => {
      this.openDialog(event as MouseEvent);
    });
  }

  private openDialog(event: MouseEvent) {
    if (event.button === 1) {
      return;
    }

    event.preventDefault();

    const newUrl = new URL(window.location.href);
    const modalQueryParam = this.element.dataset.modalQueryParam;

    newUrl.searchParams.set("modal", modalQueryParam!);

    window.history.pushState(window.history.state, "", newUrl.toString());

    const url = new URL(
      `${window.location.origin}${
        (this.element as HTMLAnchorElement).dataset.remoteUrl
      }`
    );
    if (this.element.hasAttribute("data-pathname")) {
      url.pathname += this.element.dataset.pathname!;
    }

    url.searchParams.set("frame", "true");

    const modalTemplateElement = document.getElementById("modal-template");
    if (!modalTemplateElement) {
      throw new Error("Modal template element not found");
    }
    const modalTemplate = (
      modalTemplateElement.cloneNode(true) as HTMLTemplateElement
    ).content;
    const refTitle = modalTemplate.querySelector(".ref-title");
    if (refTitle) {
      refTitle.innerHTML = this.element.dataset.title || "";
    }

    const turboFrame = document.createElement(
      "turbo-frame"
    ) as HTMLIFrameElement;
    const frameId = this.element.dataset.frameId;
    if (!frameId) {
      throw new Error("frameId is not defined in the dataset");
    }
    turboFrame.id = frameId;
    turboFrame.src = url.toString();
    turboFrame.appendChild(modalTemplate);

    this.dialog.innerHTML = "";
    this.dialog.appendChild(turboFrame);

    this.dialog.showModal();
  }

  private get dialog() {
    return document.querySelector<HTMLDialogElement>("#edit-dialog")!;
  }
}
